import { render, staticRenderFns } from "./FundsTransferCheckersQueueTable.vue?vue&type=template&id=1aedb28e&scoped=true&"
import script from "./FundsTransferCheckersQueueTable.vue?vue&type=script&lang=js&"
export * from "./FundsTransferCheckersQueueTable.vue?vue&type=script&lang=js&"
import style0 from "./FundsTransferCheckersQueueTable.vue?vue&type=style&index=0&id=1aedb28e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aedb28e",
  null
  
)

export default component.exports